<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter01">Chapter 1. Mrs. Harwood Knows</a></p>
<p class="toc"><a href="#/chapter02">Chapter 2. Media Coverage</a></p>
<p class="toc"><a href="#/chapter03">Chapter 3. The Schumachers</a></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Chapter 4. Wauwatosa in the 1920s</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Chapter 5. Buddy Disappears</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Chapter 6. The Search Begins</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Chapter 7. “We’ll Never Give Up”</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Chapter 8. Leads All Over the State</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Chapter 9. No Sign of the Boy</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Chapter 10. The Hunt Grinds to a Halt</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Chapter 11. The Body Is Finally Found</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Chapter 12. An Arrest Is Made</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Chapter 13. Suspect Linked to Murder Weapon</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">Chapter 14. The Case Suddenly Falls Apart</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">Chapter 15. A Confession</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">Chapter 16. Who Was William Brandt?</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">Chapter 17. More Violence Against Kids</span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">Chapter 18. The “Moron” Danger</span></p>
<p class="toc1"><span href="#/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f955431c